var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSharp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0l2.133 6.91h6.902l-5.584 4.27 2.133 6.91L9.5 13.82l-5.584 4.27 2.133-6.91L.465 6.91h6.902L9.5 0z",
    fill: "#008CFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSharp);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default "data:image/svg+xml,%3csvg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M9.5 0L11.6329 6.90983H18.535L12.9511 11.1803L15.084 18.0902L9.5 13.8197L3.91604 18.0902L6.04892 11.1803L0.464963 6.90983H7.36712L9.5 0Z' fill='%23008CFF'/%3e %3c/svg%3e";
export { MemoForwardRef as ReactComponent };